import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { OpfoelgningDashboardUserResponse } from 'src/app/api/models/OK/Egis/Service/Models/Response/opfoelgning-dashboard-user-response';
import { OpfoelgningDashboardParkedResponse } from 'src/app/api/models/OK/Egis/Service/Models/Response/opfoelgning-dashboard-parked-response';
import { OpfoelgningDashboardCountResponse } from 'src/app/api/models/OK/Egis/Service/Models/Response/opfoelgning-dashboard-count-response';
import { OpfoelgningDashboardPriority } from 'src/app/api/models/OK/Egis/Service/Models/Response/opfoelgning-dashboard-priority';
import { OpfoelgningService } from 'src/app/api/services/opfoelgning.service';
import { timer } from 'rxjs';
import { EGIS_SERVICE_CALLER } from '../../../constants';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TransferOpfoelgningerDialogComponent } from 'src/app/components/opfoelgning/transfer-opfoelgninger-dialog/transfer-opfoelgninger-dialog.component';
import { AuthService } from 'src/app/services/auth.service';

@Component({
    selector: 'app-opfoelgning-dashboard',
    templateUrl: './opfoelgning-dashboard.component.html',
    styleUrls: ['./opfoelgning-dashboard.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class OpfoelgningDashboardComponent implements OnInit {
  total: OpfoelgningDashboardCountResponse;
  brugere: Array<OpfoelgningDashboardUserResponse>;
  overskredetDeadline: OpfoelgningDashboardCountResponse;
  parkeret: OpfoelgningDashboardParkedResponse;
  prioritet_high: number;
  prioritet_medium: number;
  prioritet_low: number;

  canTransfer: boolean = false;

  constructor(service: OpfoelgningService, private router: Router, private dialog: MatDialog, private auth: AuthService) {
    timer(0, 60000).subscribe((t) =>
      service.getOpfoelgningDashboard({ caller: EGIS_SERVICE_CALLER }).subscribe((r) => {
        this.total = r.total;
        this.brugere = r.brugere.sort((a, b) => b.count - a.count);
        this.overskredetDeadline = r.overskredetDeadline;
        this.parkeret = r.parkeret;
        this.prioritet_high = this.percentage(r.prioritet, 1);
        this.prioritet_medium = this.percentage(r.prioritet, 2);
        this.prioritet_low = this.percentage(r.prioritet, 3);

        this.canTransfer = this.auth.isAdministrator;
      })
    );
  }

  percentage(prioriteter: OpfoelgningDashboardPriority[], priority: number): number {
    return prioriteter.find((x) => x.priority == priority)?.percentage || 0;
  }

  ngOnInit(): void {}

  transfer() {
    this.dialog.open(TransferOpfoelgningerDialogComponent);
  }
}
